import React, {useReducer, useEffect} from 'react'
import styled from 'styled-components'

const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`

const initialState = {
  building: {
    value: '',
    name: ''
  },
  floor: {
    value: '',
    name: ''
  },
  room: {
    value: '',
    name: ''
  },
  employee: {
    value: '',
    name: ''
  },
  equipment: {
    value: '',
    name: ''
  },
  department: {
    value: '',
    name: ''
  }
}

const init = state => {
  return {
    ...initialState,
    ...state
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PROMPT_VALUE':
      return {
        ...state,
        ...action.payload
      }

    case 'SET_INIT_VALUE':
      return init(action.payload)
  }
}

const Selector = ({render, onPromptChange, state}) => {
  useEffect(
    () => {
      dispatch({type: 'SET_INIT_VALUE', payload: state})
    },
    [state]
  )

  const [selector, dispatch] = useReducer(reducer, state, init)

  const onChange = ({item}) => {
    const {isClear, promptType} = item

    let changes = {
      building: {value: '', name: ''},
      floor: {value: '', name: ''},
      room: {value: '', name: ''},
      equipment: {value: '', name: ''},
      siteId: ''
    }

    if (promptType === 'BUILDING') {
      if (isClear) {
        changes = {
          building: {value: '', name: ''},
          floor: {value: '', name: ''},
          room: {value: '', name: ''}
        }
      } else {
        changes = {
          building: {value: item.blId, name: item.name},
          floor: {value: '', name: ''},
          room: {value: '', name: ''},
          siteId: isClear ? '' : item.siteId
        }
      }
    }

    if (promptType === 'FLOOR') {
      if (isClear) {
        changes = {
          floor: {value: '', name: ''},
          room: {value: '', name: ''}
        }
      } else {
        changes = {
          building: {value: item.blId, name: item.blName},
          floor: {value: item.flId, name: item.name},
          room: {value: '', name: ''},
          siteId: item.blSiteId
        }
      }
    }

    if (promptType === 'ROOM') {
      if (isClear) {
        changes = {
          room: {value: '', name: ''}
        }
      } else {
        changes = {
          room: {value: item.rmId, name: item.rmId},
          building: {value: item.blId, name: item.blName},
          floor: {value: item.flId, name: item.flName},
          siteId: item.blSiteId
        }
      }
    }

    if (promptType === 'EQUIPMENT') {
      if (isClear) {
        changes = {
          room: {value: '', name: ''},
          building: {value: '', name: ''},
          floor: {value: '', name: ''},
          equipment: {value: '', name: ''},
          siteId: ''
        }
      } else {
        changes = {
          room: {value: item.rmId, name: item.rmId},
          building: {value: item.blId, name: item.blName},
          floor: {value: item.flId, name: item.flName},
          equipment: {value: item.eqId, name: item.eqId},
          siteId: item.blSiteId
        }
      }
    }

    if (promptType === 'EMPLOYEE') {
      if (isClear) {
        changes = {
          employee: {value: '', name: ''}
        }
      } else {
        changes = {
          employee: {value: item.emId, name: item.emId}
        }
      }
    }

    if (promptType === 'DEPARTMENT') {
      if (isClear) {
        changes = {
          department: {value: '', name: ''}
        }
      } else {
        changes = {
          department: {value: item.deptCode, name: item.dpName}
        }
      }
    }

    dispatch({type: 'SET_PROMPT_VALUE', payload: changes})

    onPromptChange(changes)
  }

  return <Container>{render(selector, onChange)}</Container>
}

export default Selector
